import { mmHttp, MmRequestConfig } from './mmHttp';
import { buildPageQuery, MmPaginationState, readPage } from './pagination';
import { MmPage, MmZoningUnresolvedItem } from '../types/dto';

const ZONING_PATH = '/ml/zoning';

export interface MmZoningUnresolvedQuery {
  from: string;
  to: string;
}

function readText(value: any): string {
  if (typeof value === 'string' && value !== '') {
    return value;
  }

  return '';
}

function readNumber(value: any): number {
  return typeof value === 'number' && !isNaN(value) ? value : 0;
}

function readBoolean(value: any, fallback: boolean): boolean {
  return typeof value === 'boolean' ? value : fallback;
}

function readZoningUnresolvedItem(raw: any): MmZoningUnresolvedItem | null {
  if (!raw || typeof raw !== 'object') {
    return null;
  }

  const competitorName = readText(raw.competitorName);

  if (competitorName === '') {
    const legacy = readText(raw.competitor_name);

    if (legacy === '') {
      return null;
    }

    return {
      competitorName: legacy,
      competitorKnown: readBoolean(raw.competitorKnown, true),
      storesCount: readNumber(raw.stores_count),
      photosCount: readNumber(raw.photos_count),
    };
  }

  return {
    competitorName: competitorName,
    competitorKnown: readBoolean(raw.competitorKnown, true),
    storesCount: readNumber(raw.storesCount),
    photosCount: readNumber(raw.photosCount),
  };
}

export function fetchZoningUnresolved(
  query: MmZoningUnresolvedQuery,
  pagination: MmPaginationState,
  config?: MmRequestConfig,
): Promise<{ page: MmPage<MmZoningUnresolvedItem>; photosTotal: number }> {
  const params = buildPageQuery(pagination);

  params.from = query.from;
  params.to = query.to;

  return mmHttp
    .get(ZONING_PATH + '/unresolved', Object.assign({ params: params, mmSection: 'zoning/unresolved' }, config))
    .then((response) => {
      const envelope = response.data;
      const pageRaw = readPage<any>(envelope);
      const items: MmZoningUnresolvedItem[] = [];

      for (let i = 0; i < pageRaw.content.length; i += 1) {
        const row = readZoningUnresolvedItem(pageRaw.content[i]);

        if (row !== null) {
          items.push(row);
        }
      }

      const page: MmPage<MmZoningUnresolvedItem> = {
        content: items,
        totalElements: pageRaw.totalElements,
        totalKnown: pageRaw.totalKnown,
        hasMore: pageRaw.hasMore,
      };

      let photosTotal = 0;

      if (envelope && typeof envelope.photosTotal === 'number') {
        photosTotal = envelope.photosTotal;
      } else if (envelope && typeof envelope.photos_total === 'number') {
        photosTotal = envelope.photos_total;
      } else {
        for (let j = 0; j < items.length; j += 1) {
          photosTotal += items[j].photosCount;
        }
      }

      return { page: page, photosTotal: photosTotal };
    });
}
